import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 import {ActivatedRoute, Params} from '@angular/router';
import {Subscription} from "rxjs"; 

import {delay, map, switchMap} from 'rxjs/operators';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../../shared/services/analytic.service'
import { NbDialogService, NbToastrService } from '@nebular/theme';
 

@Component({
  selector: 'app-income-inner-page', 
  templateUrl: './income-inner-page.component.html',
  styleUrls: ['./income-inner-page.component.scss'],
  
})
export class IncomeInnerPageComponent implements OnInit, OnDestroy{
 
    lSub$:any;
    stat:any;
    id:any
 
  loading:boolean = true;

  constructor(     private analyticService: AnalyticService ,  public route:  ActivatedRoute  ){
  }
   
 
   ngOnInit() {  


  
 	this.lSub$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        	this.id = params['id']
        return this.analyticService.getIncomeInner(this.id).pipe(
          map((stat: any)=>{
 		 
	    this.stat = stat
	   this.loading = false
 
            return stat
          })
        )
      })
    ).subscribe(()=>{})
 
  }


 


   
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
   }
 
   

 
  
}
